import { render, staticRenderFns } from "./StudyResultDetailList.vue?vue&type=template&id=2510f56e&scoped=true&lang=pug"
import script from "./StudyResultDetailList.vue?vue&type=script&lang=ts"
export * from "./StudyResultDetailList.vue?vue&type=script&lang=ts"
import style0 from "./StudyResultDetailList.vue?vue&type=style&index=0&id=2510f56e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2510f56e",
  null
  
)

export default component.exports